module.exports = __webpack_public_path__ + "static/media/comments.d68b6143.svg";